import React, { ReactNode } from 'react';
import { Outlet, NavLink, useLocation, Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import './styles/LearnerLayout.css';

interface MarketplaceLayoutProps {
  children?: ReactNode;
}

const MarketplaceLayout: React.FC<MarketplaceLayoutProps> = ({ children }) => {
  const { t } = useLanguage();
  const location = useLocation();
  const isMarketplace = location.pathname.startsWith('/marketplace');
  const isLearn = location.pathname.startsWith('/learn');

  return (
    <div className="learner-layout min-h-screen bg-gray-50">
      {/* Learner Navigation - Top level navigation */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <h1 className="text-2xl font-bold text-gray-900">
                  {isMarketplace ? t('marketplace.title') || 'Marketplace' : t('learn.layout.title')}
                </h1>
              </div>
              <nav className="ml-6 flex space-x-4 sm:space-x-8">
                {/* Top level menu items */}
                <NavLink
                  to="/marketplace"
                  end
                  className={({ isActive }) =>
                    isActive
                      ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                  }
                >
                  {t('marketplace.menu.home') || 'Cổng khoá học'}
                </NavLink>
                <NavLink
                  to="/marketplace/courses"
                  className={({ isActive }) =>
                    isActive
                      ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                  }
                >
                  {t('marketplace.menu.courseCatalog') || 'Danh mục khoá học'}
                </NavLink>
                
                <NavLink
                  to="/learn"
                  className={({ isActive }) =>
                    isActive || isLearn
                      ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                  }
                >
                  {t('learn.layout.myCorner') || 'Góc của tôi'}
                </NavLink>
              </nav>
            </div>
            
            {/* Back to Admin Panel Link */}
            <div className="flex items-center">
              <Link
                to="/"
                className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
              >
                {t('common.adminPanel') || 'Admin Panel'}
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Content Area */}
      {isLearn ? (
        // Render children directly when in learn section
        <>{children}</>
      ) : (
        // Otherwise render the marketplace content
        <main className={isMarketplace ? "marketplace-layout" : "py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full"}>
          <div className={isMarketplace ? "marketplace-container" : ""}>
            <Outlet />
          </div>
        </main>
      )}
    </div>
  );
};

export default MarketplaceLayout; 